import { Component, type ErrorInfo, type ReactNode } from 'react';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

export default class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if ('reportError' in window && typeof window.reportError === 'function') {
      window.reportError(new AggregateError([error], info.componentStack ?? 'React render error'));
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="min-h-dvh bg-surface-50 px-4 flex items-center justify-center">
          <section className="raised-panel w-full max-w-lg rounded-lg border border-surface-200 p-8 text-center">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-md bg-accent-50 text-accent-700">
              <i className="ri-error-warning-line text-xl" aria-hidden="true" />
            </div>
            <h1 className="text-xl font-semibold text-surface-900">Не удалось открыть страницу</h1>
            <p className="mt-2 text-sm text-surface-500">
              Обновите приложение. Если ошибка повторится, передайте команде адрес страницы и время
              сбоя.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-6 rounded-lg bg-accent-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-accent-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-500 focus-visible:ring-offset-2"
            >
              Обновить страницу
            </button>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
